import { render, staticRenderFns } from "./CounselorBySpecialty.vue?vue&type=template&id=1947c0da&scoped=true&"
import script from "./CounselorBySpecialty.vue?vue&type=script&lang=js&"
export * from "./CounselorBySpecialty.vue?vue&type=script&lang=js&"
import style0 from "./CounselorBySpecialty.vue?vue&type=style&index=0&id=1947c0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947c0da",
  null
  
)

export default component.exports